import type { ParsedUrlQuery } from 'querystring';

// gloss
export const shouldShowSignup = (query: ParsedUrlQuery): boolean =>
  query.signup === 'true' || query.mode === 'signup' || Boolean(query.inviteTag);
